import routes from '@/routes';

export default {
  methods: {
    route(name) {
      return routes[name]
        // ? process.env.MIX_APP_BASE_URL + routes[name]
        ? routes[name]
        : null;
    },
  },
}
